import React from 'react';
import FormRow from "../../../../Components/HorizontalForm/FormRow";
import CheckboxInput from "../../../../Components/Inputs/CheckboxInput";
import EntityConfigSection from "../../Components/EntityConfigSection";
import StackedFormRow from "../../../../Components/StackedForm/StackedFormRow";
import { formatDuration } from "../../../../Helpers/DateTimeHelper";

export const MIN_VARIABLE_AMENITY_PAYMENT = 120;
export const MIN_FIXED_AMENITY_PAYMENT = 30;

const EntityPaymentConfig = (props) => {

    const handleUpdatePaymentEnabled = (e) => {
        if (e.target.checked) {
            props.onChanges({
                payment_enabled: true,
                payment_amount: (props.config.is_variable === 1) ? MIN_VARIABLE_AMENITY_PAYMENT : MIN_FIXED_AMENITY_PAYMENT,
                recurring_bookings: false,
                payment_receipt_sent_to_email: false,
            })
        } else {
            props.onChanges({
                payment_enabled: false,
                payment_amount: 0,
            });
        }
    }

    return (<>
        <EntityConfigSection
            title="Payment"
            isExpanded={props.isExpanded}
        >
            <FormRow
                label="Payment Enabled"
                errorMessage={props.errors.payment_enabled}
                className="align-middle"
                leftCellClassName="cell small-12 medium-4"
                rightCellClassName="cell small-12 medium-3 text-right"
            >
                <CheckboxInput
                    name="payment_enabled"
                    checked={props.config.payment_enabled}
                    onChange={handleUpdatePaymentEnabled}
                />
            </FormRow>

            { (props.config.payment_enabled) && (<>
                <FormRow
                    label={
                        (props.config.is_variable === 1)
                            ? "Pricing per hour (pence)"
                            : "Pricing per slot (pence)"
                    }
                    errorMessage={props.errors.payment_amount}
                    className="align-middle"
                    leftCellClassName="cell small-12 medium-4"
                    rightCellClassName="cell small-12 medium-3 text-right"
                >
                    <input
                        type="number"
                        name="payment_amount"
                        value={props.config.payment_amount}
                        onChange={e => props.onChange(e.target.name, e.target.value)}
                        min={
                            (props.config.is_variable === 1)
                                ? MIN_VARIABLE_AMENITY_PAYMENT
                                : MIN_FIXED_AMENITY_PAYMENT
                        }
                        max={999900}
                        style={{ maxWidth: 83 }}
                    />
                </FormRow>

                <FormRow
                    label="Send payment receipt to user via email?"
                    errorMessage={props.errors.payment_receipt_sent_to_email}
                    className="align-middle margin-top-1"
                    leftCellClassName="cell small-12 medium-4"
                    rightCellClassName="cell small-12 medium-3 text-right"
                    tooltip="Ensure that stripe dashboard is correctly configured to use this feature. https://dashboard.stripe.com/settings/emails -> Customer Emails -> Payments -> Successful payments"
                >
                    <CheckboxInput
                        name="payment_receipt_sent_to_email"
                        checked={(props.config.payment_receipt_sent_to_email)}
                        onChange={(e) => { props.onChange('payment_receipt_sent_to_email', e.target.checked) }}
                    />
                </FormRow>

                <FormRow
                    label="Has Cancellation Window?"
                    className="align-middle margin-top-1"
                    leftCellClassName="cell small-12 medium-4"
                    rightCellClassName="cell small-12 medium-3 text-right"
                >
                    <CheckboxInput
                        name=""
                        checked={(props.config.cancellation_window !== false && props.config.cancellation_window !== null)}
                        onChange={e => {
                            (e.target.checked)
                                ? props.onChange('cancellation_window', 60)
                                : props.onChange('cancellation_window', false)
                        }}
                    />
                </FormRow>

                {(!!props.config.cancellation_window) &&
                    <StackedFormRow
                        label="Cancellation window (minutes)"
                        errorMessage={props.errors.cancellation_window}
                        className="align-middle"
                        labelClassName="margin-bottom-0"
                    >
                        <div className="grid-x">
                            <div className="cell small-2">
                                <input
                                    type="number"
                                    name="cancellation_window"
                                    value={props.config.cancellation_window}
                                    onChange={e => {
                                        const value = (e.target.value) ? e.target.value : '0';
                                        props.onChange(e.target.name, value);
                                    }}
                                    min={0}
                                    style={{ maxWidth: 100 }}
                                />
                            </div>
                            <div className="cell small-10" style={{paddingTop: '0.6rem'}}>
                            <span>
                                {formatDuration(props.config.cancellation_window)}
                            </span>
                            </div>
                        </div>
                    </StackedFormRow>
                }

            </>)}
        </EntityConfigSection>
    </>);
};

export default EntityPaymentConfig;
